export const globalMixins = {
	data() {
		return {
			colorLoader: '#009DE0',
		}
	},
	created() {
		this.$isEmpty = function (value) {
			if (value === null || value === undefined) {
				return true;
			}
			if (typeof value === 'string' || Array.isArray(value)) {
				return value.length === 0;
			}
			if (typeof value === 'object') {
				return Object.keys(value).length === 0;
			}
			return false;
		}

		this.$getFirstValueObject = function (curObject) {
			if (this.$isEmpty(curObject)) {
				return '';
			}
			return Object.values(curObject)[0];
		}

		this.$getFirstValueInsertedObject = function (curObject) {
			let valueObject = this.$getFirstValueObject(curObject);
			if (valueObject === '') {
				return '';
			}
			if(Array.isArray(valueObject)){
				return valueObject;
			}
			if (typeof valueObject === 'object') {
				return this.$getFirstValueInsertedObject(valueObject);
			}
			return valueObject;
		}

		this.$getNameByLocale = function (arrayName, curLocale){
			if(!Array.isArray(arrayName)) {
				return '';
			}
			const result = arrayName.filter(item => item.locale === curLocale);
			return result.length === 0 ? '' : result[0].value;
		}
	},
}
